// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"price":{"f":""},"development_estimatedCompletion":{"b":""},"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function newDevelopmentUnitType_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY") {
    return $$enum;
  }
}

let newDevelopmentUnitType_fromString = newDevelopmentUnitType_decode;

let Utils = {
  newDevelopmentUnitType_decode: newDevelopmentUnitType_decode,
  newDevelopmentUnitType_fromString: newDevelopmentUnitType_fromString
};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentUnitSearchResult_newDevelopmentUnit",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unitType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "beds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baths",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "squareFeet",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": [
            {
              "kind": "Literal",
              "name": "priceFormat",
              "value": "FULL"
            },
            {
              "kind": "Literal",
              "name": "priceRangeFormat",
              "value": "SHORT"
            }
          ],
          "kind": "FragmentSpread",
          "name": "PropertyPrice_propertyPrice"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NewDevelopmentUnitDevelopment",
      "kind": "LinkedField",
      "name": "development",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "developer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "estimatedCompletion",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentUnitSearchResultCard_newDevelopmentUnit"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentUnitSearchResultTitleAndLocation_newDevelopmentUnit"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentUnitSearchResultAgent_newDevelopmentUnit"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentUnitSearchResultTimestamp_newDevelopmentUnit"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentUnitSearchResultActions_newDevelopmentUnit"
    }
  ],
  "type": "NewDevelopmentUnit",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
